var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
let AbstractNotification = class AbstractNotification extends Vue {
    transformNotification(notification, isShowingArchived = false) {
        const notificationKey = (notification && notification.key);
        switch (notificationKey) {
            case 'subject.finished':
            case 'subject:status.finished':
                return this.transformSubjectFinished(notification, isShowingArchived);
        }
        const notificationType = (notification && notification.type);
        switch (notificationType) {
            case 'subject.finished':
            case 'subject:status.finished':
                return this.transformSubjectFinished(notification, isShowingArchived);
        }
        return this.transformChatMessageReceived(notification, isShowingArchived);
    }
    transformSubjectFinished(notification, isShowingArchived = false) {
        const studentSubject = notification && notification.meta && notification.meta.subject_student;
        notification.title = this.$tc('notifications.finished.title');
        notification.subtitle = notification.meta.subject_student.name;
        notification.bundle_id = notification.meta.subject_student.id || '';
        notification.action = `/students/${studentSubject.user}/school-tracker?subject=${studentSubject.id}`;
        return notification;
    }
    transformChatMessageReceived(notification, isShowingArchived = false) {
        const user = (notification.meta && notification.meta && notification.meta.message && notification.meta.message.user) || notification.notifiable;
        notification.title = 'N/A';
        notification.subtitle = '-';
        notification.avatar = '';
        notification.bundle_id = notification.meta && notification.meta.message && notification.meta.message.notification_target && notification.meta.message.notification_target.id || '';
        let subject = null;
        switch (notification.key) {
            case 'student.idp.subject':
                subject = notification.meta.message.notification_target;
                if (!subject || !subject.status) {
                    if (isShowingArchived) {
                        notification.title = `${this.$t('deleted')}`;
                        notification.subtitle = `<span class="accentText">${user.name}</span> ${this.$t('notifications.message.content')} <span class="accentText">${this.$t('subject.deleted')}</span> ${this.$t('notifications.message.at')} <span class="accentText">${notification.created_at}</span>.`;
                        notification.avatar = (notification.meta.message.user) ? notification.meta.message.user.avatar : '';
                        notification.action = ``;
                        return notification;
                    }
                    return;
                }
                notification.title = `${notification.meta.message.notification_target.name}`;
                notification.subtitle = `<span class="accentText">${user.name}</span> ${this.$t('notifications.message.content')} <span class="accentText">${subject.name}</span> ${this.$t('notifications.message.at')} <span class="accentText">${notification.created_at}</span>.`;
                notification.avatar = notification.meta.message.user.avatar;
                notification.action = `/students/${subject.status.user}/school-tracker?subject=${subject.status.id}`;
                break;
            case 'student.messages.student-guardian':
                subject = notification.meta.message.notification_target;
                notification.title = `${subject ? subject.name : ''}`;
                notification.subtitle = `<span class="accentText">${user ? user.name : ''}</span> ${this.$t('notifications.message.content')} <span class="accentText">${subject ? subject.name : ''}</span> ${this.$t('notifications.message.at')} <span class="accentText">${notification.created_at}</span>.`;
                notification.avatar = subject ? subject.avatar : '';
                notification.action = `/students/${subject ? subject.id : ''}/messages?tab=student-guardian`;
                break;
            case 'student.messages.guardian':
                subject = notification.meta.message.notification_target;
                notification.title = `${subject.name}`;
                notification.subtitle = `<span class="accentText">${user.name}</span> ${this.$t('notifications.message.content')} <span class="accentText">${subject.name}</span> ${this.$t('notifications.message.at')} <span class="accentText">${notification.created_at}</span>.`;
                notification.avatar = subject.avatar;
                notification.action = `/students/${subject.id}/messages?tab=guardian`;
                break;
            case 'subject.messages':
                subject = notification.meta.message.notification_target;
                notification.title = `${subject.name}`;
                notification.subtitle = `<span class="accentText">${user.name}</span> ${this.$t('notifications.message.content')} <span class="accentText">${subject.name}</span> ${this.$t('notifications.message.at')} <span class="accentText">${notification.created_at}</span>.`;
                notification.avatar = null;
                notification.action = `/subjects/${subject.id}?tab=messages`;
                break;
            case 'student.messages.teacher':
                subject = notification.meta.message.notification_target;
                notification.subject = `${subject.name}`;
                notification.subtitle = `<span class="accentText">${user.name}</span> ${this.$t('notifications.message.content')} <span class="accentText">${subject.name}</span> ${this.$t('notifications.message.at')} <span class="accentText">${notification.created_at}</span>.`;
                notification.avatar = subject.avatar;
                notification.action = `/students/${subject.id}/messages?tab=teacher`;
                break;
            case 'group.messages':
                subject = notification.meta.message.notification_target ? notification.meta.message.notification_target : null;
                if (!subject) {
                    return notification;
                }
                notification.title = `${subject.name}`;
                notification.subtitle = `<span class="accentText">${user.name}</span> ${this.$t('notifications.message.content')} <span class="accentText">${subject.name}</span> ${this.$t('notifications.message.at')} <span class="accentText">${notification.created_at}</span>.`;
                notification.avatar = user.avatar;
                notification.action = `/groups/${subject.id}/messages`;
                break;
        }
        return notification;
    }
    emptyNotification() {
        return;
    }
};
AbstractNotification = __decorate([
    Component({})
], AbstractNotification);
export default AbstractNotification;
